<div class="card json-container">
  <div *ngIf="tileInstance">
    <h4>{{ tileInstance.tileType }} is an invalid tile type.</h4>
  </div>
  <div *ngIf="!tileInstance">
    <suvo-core-error-message title="No Tile Definition"></suvo-core-error-message>
  </div>
</div>
